module.exports = __webpack_public_path__ + "img/joe-moore.b58989b6.jpg";